// Copied over from https://github.com/carbon-design-system/carbon/blob/master/packages/react/src/components/NumberInput/NumberInput.js
// Need a way to replace up/down arrows with plus/minus

import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import classNames from 'classnames';
import { settings } from 'carbon-components';

const { prefix } = settings,

    AddGlyph = () => (
        <svg width='24' height='24' xmlns='http://www.w3.org/2000/svg'>
            <path d='M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm0-2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z' />
            <path d='M13 13v4h-2v-4H7v-2h4V7h2v4h4v2h-4z' />
        </svg>
    ),

    SubtractGlyph = () => (
        <svg width='24' height='24' xmlns='http://www.w3.org/2000/svg'>
            <path d='M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm0-2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z' />
            <path d='M17 11v2H7v-2z' />
        </svg>
    ),

    capMin = (min, value) =>
        isNaN(min) || (!min && min !== 0) || isNaN(value) || (!value && value !== 0)
            ? value
            : Math.max(min, value),

    capMax = (max, value) => {
        return isNaN(max) ||
        (!max && max !== 0) ||
        isNaN(value) ||
        (!value && value !== 0)
            ? value
            : Math.min(max, value);
    };

export default class InputStepper extends Component {
    constructor(props) {
        super(props);
        let value = props.value;
        const { min } = props;

        if (min || min === 0) {
            value = Math.max(min, value);
        }

        this.state = { value };
    }

    handleChange = evt => {
        const { disabled, onChange, min, max } = this.props,
            value = capMax(max, capMin(min, Number(evt.target.value)));

        if (!disabled) {
            evt.persist();
            this.setState({ value }, () => {
                onChange(value);
            });
        }
    };

    handleArrowClick = (evt, direction) => {
        let value =
            typeof this.state.value === 'string'
                ? Number(this.state.value)
                : this.state.value;

        const { disabled, min, max, onClick, onChange, step } = this.props,

            conditional =
            direction === 'down'
                ? (min !== undefined && value > min) || min === undefined
                : (max !== undefined && value < max) || max === undefined;

        if (!disabled && conditional) {
            value = direction === 'down' ? value - step : value + step;
            evt.persist();

            this.setState({ value }, () => {
                onClick(value, direction);
                onChange(value, direction);
            });
        }
    };

    render() {
        const {
                className,
                disabled,
                id,
                hideLabel,
                step,
                invalid,
                invalidText,
                helperText,
                allowEmpty,
                min,
                max,
                description,
                value,
                label,
                readOnly,
                ...other
            } = this.props,

            numberInputClasses = classNames(
                `${prefix}--number--mobile`,
                `${prefix}--number ${prefix}--number--helpertext`,
                className,
                {
                    [`${prefix}--number--nolabel`]: hideLabel
                }
            ),

            props = {
                disabled,
                id,
                max,
                min,
                step,
                onChange: this.handleChange,
                value: this.state.value
            },

            inputWrapperProps = {};

        let error = null,
            descriptionText = null,
            labelClasses = null,
            labelText = null;

        if (invalid || (!allowEmpty && this.state.value === '')) {
            inputWrapperProps['data-invalid'] = true;
            error = (
                <div className={`${prefix}--form-requirement`}>
                    {invalidText}
                </div>
            );
        }

        descriptionText = description ? <div className={`${prefix}--form__helper-text`}>{description()}</div> : null;

        labelClasses = classNames(`${prefix}--label`, {
            [`${prefix}--visually-hidden`]: hideLabel
        });

        labelText = label ? <label htmlFor={id} className={labelClasses}> {label} </label> : null;

        return (
            <div className='ht-field ht-stepperfield'>
                <div className={numberInputClasses} {...inputWrapperProps}>
                    <>
                        {labelText}
                        {descriptionText}
                        <div className={`${prefix}--number__input-wrapper`}>
                            <button
                                type='button'
                                disabled={this.state.value === min || disabled ||
                                readOnly}
                                className={`${prefix}--number__control-btn down-icon`}
                                onClick={evt => this.handleArrowClick(evt, 'down')}
                                title='Decrement number'
                                aria-label='Decrement number'
                                aria-live='polite'
                                aria-atomic='true'
                            >
                                <SubtractGlyph className='down-icon' />
                            </button>
                            <input
                                type='number'
                                pattern='[0-9]*'
                                onBlur={other.onBlur}
                                onFocus={other.onFocus}
                                onReset={other.onReset}
                                onSubmit={other.onSubmit}
                                disabled={disabled}
                                readOnly={readOnly}
                                {...props}
                            />
                            <button
                                type='button'
                                disabled={
                                    this.state.value === max ||
                                    disabled ||
                                    readOnly
                                }
                                className={`${prefix}--number__control-btn up-icon`}
                                onClick={evt => this.handleArrowClick(evt, 'up')}
                                title='Increment number'
                                aria-label='Increment number'
                                aria-live='polite'
                                aria-atomic='true'
                            >
                                <AddGlyph className='up-icon' />
                            </button>
                        </div>
                    </>
                    {error}
                </div>
            </div>
        );
    }
}

InputStepper.propTypes = {
    id: PropTypes.string.isRequired,
    allowEmpty: PropTypes.bool,
    className: PropTypes.string,
    description: PropTypes.func,
    disabled: PropTypes.bool,
    helperText: PropTypes.node,
    hideLabel: PropTypes.bool,
    invalid: PropTypes.bool,
    invalidText: PropTypes.string,
    label: PropTypes.string,
    max: PropTypes.number,
    min: PropTypes.number,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    readOnly: PropTypes.bool,
    step: PropTypes.number,
    value: PropTypes.number
};

InputStepper.defaultProps = {
    allowEmpty: false,
    className: '',
    description: null,
    disabled: false,
    helperText: null,
    hideLabel: false,
    invalid: false,
    invalidText: 'Provide invalidText',
    label: ' ',
    max: 2,
    min: 0,
    onChange: () => {},
    onClick: () => {},
    readOnly: false,
    step: 1,
    value: 0
};
